import { useEffect, useMemo } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import { getKonspektExtensions } from '../konspekt/konspektEditorExtensions';

export default function KonspektTiptapView({ docJson }) {
  const extensions = useMemo(() => getKonspektExtensions({ editable: false }), []);
  const editor = useEditor({
    extensions,
    content: docJson || { type: 'doc', content: [{ type: 'paragraph' }] },
    editable: false,
  });

  useEffect(() => {
    if (!editor || !docJson) return;
    editor.commands.setContent(docJson);
  }, [editor, docJson]);

  if (!editor) {
    return <div className="konspekt-readonly-loading">Загрузка…</div>;
  }

  return (
    <div className="konspekt-readonly konspekt-tiptap-shell">
      <EditorContent editor={editor} />
    </div>
  );
}
